var React = require('react');

function Surprise (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM136,208a32,32,0,1,1,32,32A32,32,0,0,1,136,208ZM248,416a64,64,0,1,1,64-64A64,64,0,0,1,248,416Zm80-176a32,32,0,1,1,32-32A32,32,0,0,1,328,240Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M328,176a32,32,0,1,0,32,32A32,32,0,0,0,328,176Zm-160,0a32,32,0,1,0,32,32A32,32,0,0,0,168,176Z","className":"fa-primary","key":2})]);
}

Surprise.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = Surprise;

Surprise.default = Surprise;
